import React from 'react';
import PropTypes from 'prop-types';

// App components.
import Logo from 'app/client/components/Logo';

// HOC and store.
import Breadcrumbs from 'app/client/components/Breadcrumbs';
import boost from 'app/client/utilities/hoc/boost';
import store from './store';

// Local components.
import Settings from './components/Settings';
import Search from './components/Search';

// Styled.
import * as S from './styled';

const Navbar = ({
  authenticated,
  authorized,
  canSwitchCustomer,
  language,
  actions,
  user,
  settingsLoading,
}) => (
  <S.Navbar authorized={authorized}>
    {!authorized && (
      <S.Header>
        <Logo />
      </S.Header>
    )}
    {authorized && (
      <S.Header>
        <Breadcrumbs />
      </S.Header>
    )}
    <S.Actions>
      {authorized && <Search />}
      <Settings
        user={user}
        language={language}
        actions={actions}
        authenticated={authenticated}
        authorized={authorized}
        canSwitchCustomer={canSwitchCustomer}
        settingsLoading={settingsLoading}
      />
    </S.Actions>
  </S.Navbar>
);

Navbar.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    emailAddress: PropTypes.string,
  }),
  authenticated: PropTypes.bool.isRequired,
  authorized: PropTypes.bool.isRequired,
  canSwitchCustomer: PropTypes.bool,
  language: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    setLanguage: PropTypes.func.isRequired,
  }).isRequired,
  settingsLoading: PropTypes.bool.isRequired,
};

export default boost({ store })(Navbar);
